module.exports = __webpack_public_path__ + "img/cover-2.928fc055.svg";